import { bitmaskGet } from "../bitmask";

export interface Drawing {
  id: string;
  width: number; // number of x tiles
  height: number; // number of y tiles
  palette: Uint32Array; // 32-bit to store RGB hex val
  showing: Uint32Array; // bitmask of shown colours
  mosaic: Uint8Array; // the mosaic data, 1 byte per tile, the index in the palette
  clicks: Uint32Array; // 32-bit to store coord
  hints: number; // number of times a hint was used
  lastModified?: number; // timestamp
}

/**
 * @deprecated
 */
export function drawingSize(d: Drawing): { width: number; height: number } {
  return d;
}

export function stars(hintCount: number): number {
  if (hintCount <= 1) return 5;
  if (hintCount >= 2 && hintCount <= 5) return 4;
  if (hintCount >= 6 && hintCount <= 12) return 3;
  if (hintCount >= 13 && hintCount <= 20) return 2;
  return 1; // >20 hints is 1★
}

function isShown(d: Drawing, x: number, y: number): boolean {
  return bitmaskGet(d.showing, d.width, x, y);
}

export function getProgress(
  size: number,
  showingN: number,
  clicks: number
): number {
  const backgroundSize = showingN - clicks; // number of tiles revealed without a click
  const sizeWithBackground = size - backgroundSize;
  return sizeWithBackground > 0 ? clicks / sizeWithBackground : 1;
}

// todo: memoize this?

export function toPng(
  d: Drawing,
  tileSize = 10,
  hidden: "hide" | "show" | "alpha" = "hide"
): Promise<[Blob, number]> {
  const canvas = document.createElement("canvas");
  canvas.width = d.width * tileSize;
  canvas.height = d.height * tileSize;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Failed to get canvas context");

  // draw each tile as a tileSize×tileSize square
  let showing = 0;
  for (let i = 0; i < d.mosaic.length; i++) {
    const x = i % d.width;
    const y = Math.floor(i / d.width);
    if (hidden === "hide" && !isShown(d, x, y)) continue;
    const colorIndex = d.mosaic[i];
    const paletteColor = d.palette[colorIndex] ?? 0xffffffff;
    const r = (paletteColor >> 16) & 0xff;
    const g = (paletteColor >> 8) & 0xff;
    const b = paletteColor & 0xff;
    if (hidden === "alpha" && !isShown(d, x, y)) {
      ctx.fillStyle = "rgb(255,255,255)";
      ctx.fillRect(x * tileSize, y * tileSize, tileSize, tileSize);
      ctx.fillStyle = `rgba(${r},${g},${b},0.1)`;
    } else {
      ctx.fillStyle = `rgb(${r},${g},${b})`;
      showing++;
    }
    ctx.fillRect(x * tileSize, y * tileSize, tileSize, tileSize);
  }

  // draw a progress bar along the bottom if there are clicks
  const progress = getProgress(d.mosaic.length, showing, d.clicks.length);
  // ctx.fillStyle = "rgb(0,0,0)";
  // const size = 10;
  // const gap = 0;
  // ctx.fillRect(0, canvas.height - (size + gap), canvas.width, size);
  // ctx.fillStyle = "rgb(255,255,255)";
  // // draw a smaller white bar on top
  // const fullWidth = canvas.width - 10;
  // ctx.fillRect(
  //   5,
  //   canvas.height - (size + gap) + size / 4,
  //   fullWidth * progress,
  //   size / 2
  // );

  return new Promise<[Blob, number]>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve([blob, progress]);
      } else {
        reject(new Error("Failed to convert canvas to Blob"));
      }
    }, "image/png");
  });
}
